/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_ecc_h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High`)
};

const es_qr_ecc_h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alta`)
};

const de_qr_ecc_h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoch`)
};

const nl_qr_ecc_h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoog`)
};

const fr_qr_ecc_h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Élevée`)
};

const it_qr_ecc_h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alta`)
};

const pt_br2_qr_ecc_h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alta`)
};

const pt_qr_ecc_h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alta`)
};

const ja_qr_ecc_h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高`)
};

const zh_qr_ecc_h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_ecc_h = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_ecc_h(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_ecc_h", locale)
	if (locale === "en") return en_qr_ecc_h(inputs)
	if (locale === "es") return es_qr_ecc_h(inputs)
	if (locale === "de") return de_qr_ecc_h(inputs)
	if (locale === "nl") return nl_qr_ecc_h(inputs)
	if (locale === "fr") return fr_qr_ecc_h(inputs)
	if (locale === "it") return it_qr_ecc_h(inputs)
	if (locale === "pt-BR") return pt_br2_qr_ecc_h(inputs)
	if (locale === "pt") return pt_qr_ecc_h(inputs)
	if (locale === "ja") return ja_qr_ecc_h(inputs)
	return zh_qr_ecc_h(inputs)
};